<div #confirmSaveModal>
  <div class="modal-header">
    <h4 class="modal-title">{{item.company.name}} {{item.company.ticker ? "(" + item.company.ticker + ")" : ''}}</h4>
    <button type="button" class="btn btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="confirm-modal-container p-2">
    {{'Do you want to save these changes made to ' + item.company.ticker + '?'}}
    <ul>
      <li *ngIf="newValues['fv'] || newValues['fv'] === 0" class="d-flex flex-row align-items-center">
        <div class="change-type px-1">FV:</div>
        <h4 class="change mb-0">{{newValues['fv']}}</h4>
      </li>
      <li *ngIf="newValues['dfv'] || newValues['dfv'] === 0" class="d-flex flex-row align-items-center">
        <div class="change-type px-1">DFV:</div>
        <h4 class="change mb-0">{{newValues['dfv']}}</h4>
      </li>
      <li *ngIf="newValues['pos'] || newValues['pos'] === 0" class="d-flex flex-row align-items-center">
        <div class="change-type px-1">POS:</div>
        <h4 class="change mb-0">{{newValues['pos']}}%</h4>
      </li>
    </ul>
  </div>

  <div class="modal-footer">
    <div class="btn btn-default" (click)="close()">{{"GENERICS.CANCEL" | translate}}</div>
    <div class="btn btn-primary" (click)="save()">{{"GENERICS.SAVE" | translate}}</div>
  </div>
</div>
